import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

export const fetchTicketsVendus = ({ date, filter, scope, tirageFrom, tirageUp, statut }) =>
  apiRequest(`/tickets/tickets-vendus/${toQuery({
    date, filter, scope, tirage_from: tirageFrom, tirage_up: tirageUp, statut,
  })}`);
